'use client';
import { useEffect, useRef } from 'react';
import { useProduct } from '@/contexts/ProductContext';
import { usePricing } from '@/contexts/PricingContext';
import { klaviyoViewedProduct } from '@/lib/klaviyo/events';

/**
 * Sends Klaviyo "Viewed Product" once per PDP visit, for the variant the page
 * resolves to. Unlike ElevarProduct it doesn't refire on variant changes, so a
 * visitor comparing sizes doesn't create one event per click. Mount with
 * `key={slug}` so client-side navigation to another PDP fires again.
 */
export default function KlaviyoViewedProduct() {
  const pricing = usePricing();
  const { productData, selectedVariant, hasResolvedPersistedOptions } = useProduct();
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (!hasResolvedPersistedOptions || hasFiredRef.current) return;

    hasFiredRef.current = true;
    klaviyoViewedProduct(productData, selectedVariant, pricing);
  }, [productData, selectedVariant, hasResolvedPersistedOptions, pricing]);

  return null;
}
